import React from "react";
import { Switch, Route } from "react-router-dom";

import Home from "../pages/home";
import Profile from "../pages/profile";
import CreatePlan from "../pages/create-plan";
import RandomPlan from "../pages/random-plan";
import PrintPlan from "../pages/print-plan";

const Routes = () => {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/me" exact component={Profile} />
      <Route path="/create/:date?" exact component={CreatePlan} />
      <Route path="/randomize/:date?" exact component={RandomPlan} />
      <Route path="/print/:from/:to" exact component={PrintPlan} />
      <Route path="/:date" component={Home} />
    </Switch>
  );
};

export default Routes;
